import { Tooltip } from '@mui/material';
import { CellProps } from 'react-table';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';

import { MailboxContent } from '@work4all/models/lib/Classes/MailboxContent.entity';
import { MailAssignStatus } from '@work4all/models/lib/Enums/MailAssignStatus.enum';

import { useTableLayoutState } from '../../table-layout';
import { useMailboxContentManagerContext } from '../mailbox-content-manager-context';

import { PickerTargetButton } from './components/PickerTargetButton';
import { SuggestionsFoundText } from './components/SuggestionsFoundText';
import { ContactOrBusinessPartnerPicker } from './ContactOrBusinessPartnerPicker';
import { contactAsString, ContactText } from './ContactText';

export function MailboxContentContactCell(
  props: CellProps<MailboxContent, MailAssignStatus>
) {
  const mailboxContent = props.row.original;
  const id = mailboxContent.id;

  const context = useMailboxContentManagerContext();

  const item = context.state.itemsById[id];

  const layoutState = useTableLayoutState();
  const [layout] = layoutState;

  const isEditable =
    mailboxContent.assignStatus === MailAssignStatus.NOT_YET_ASSIGNED;

  const value = isEditable
    ? item?.contact
    : mailboxContent?.convertedMail?.businessPartner?.data ?? null;

  const possibleSenders = mailboxContent.possibleSenders;

  const textVariant = layout === 'cards' ? 'caption' : 'body2';

  if (!isEditable) {
    return (
      <Tooltip title={contactAsString(value)}>
        <ContactText contact={value} variant={textVariant} />
      </Tooltip>
    );
  }

  return (
    <EntityPickerPopover
      picker={
        <ContactOrBusinessPartnerPicker
          value={value}
          onChange={(value) => {
            context.onContactChange(id, value);
          }}
          suggestions={possibleSenders}
        />
      }
    >
      <Tooltip title={contactAsString(value)}>
        <PickerTargetButton
          disabled={!isEditable}
          layout={layout}
          style={{ padding: 0 }}
        >
          {value ? (
            <ContactText contact={value} variant={textVariant} />
          ) : (
            <SuggestionsFoundText
              suggestions={possibleSenders}
              layout={layout}
            />
          )}
        </PickerTargetButton>
      </Tooltip>
    </EntityPickerPopover>
  );
}
